// Vendors
import React from 'react';
// Components
import { HeaderLayoutComponent } from 'components/header-layout/header-layout.component';
import { LoadingComponent } from 'components/loading/loading.component';
// Constants
import { APP_INFORMATION_PROVIDER_LOADING_PROPS } from 'providers/app-information/constants/app-information.constants';
// Contexts
import { useAppInformationContextConsumerHook } from 'contexts/app-information.context';
// Styles
import { AppInformationComponentStyled } from './app-information.component.styled';
// Types
import { ReactChildrenType } from '@openbank/ziniaweb-ui-core-models';
// Utilities
import { allNeedDataIsLoaded } from './utils/app-information.utils';

const AppInformationProvider = ({ children }: ReactChildrenType): React.ReactElement => {
  const { informationFlags } = useAppInformationContextConsumerHook();

  return (
    <HeaderLayoutComponent>
      <AppInformationComponentStyled fetching={!allNeedDataIsLoaded(informationFlags)}>
        <LoadingComponent
          {...APP_INFORMATION_PROVIDER_LOADING_PROPS}
          fetching={!allNeedDataIsLoaded(informationFlags)}
        >
          {children}
        </LoadingComponent>
      </AppInformationComponentStyled>
    </HeaderLayoutComponent>
  );
};

export { AppInformationProvider };
